export const data = [
  {
    id: 1,
    title: "Q1 2024",
    text: `Main Idea of the Project \n create ENTY Token as ERC20 Utility Token at Polygon! \n PolygonScan verification \n ENTY Token Audit \n Docs / Github Account
    Whitepaper Announcement / Gitbook
    Website Release
    Pre-sale site development
    Roadmap Q1 - Q4 2023
    ICO Pre-sale site Release
    CEO is KYC approved
    Social Media Accounts (Twitter, Facebook, Telegram etc)`,
  },
  {
    id: 2,
    title: "Q2 2024",
    text: `Pre-sale Round 1 (Whitelisting) starts
    PR Marketing
    Big media campaign by Influencers
    Pre-sale: Second Marketing Campaign
    Ending of the Pre-sale Round 1
    Staking DApp development
    unveiling of the development Team
    staking DApp on testnet
    Staking DApp Release
    Release of our Headquarter in Europe`,
  },

  {
    id: 3,
    title: "Q3 2023",
    text: `Influencer Marketing
    Pre-sale Round 2 start
    Pre-sale: Third Marketing Campaign
    Start of our Mobile Neobank Application iOS and Android development
    Pre-sale Round 2 end
    continuous testing of the mobile app`,
  },

  {
    id: 4,
    title: "Q4 2024",
    text: `Pre-sale Round 3 will start
    Fourth PR Marketing Campaign
    Pre-sale Round 3 will end
    Release of the First DEX listing
    Public Sale (DEX Launch will start)
    Fifth Hugh Marketing Campaign
    Coimarketcap listing
    Coingecko listing
    dappradar listing
    different other Stats site listings`,
  },

  {
    id: 5,
    title: "Q5 2023",
    text: `Our comprehensive whitepaper explores \n the cutting-edge technology behind \n Enter App`,
  },
];
